import React from "react"
import { graphql, StaticQuery } from "gatsby"
import styled from "styled-components"
import BackgroundImage from "gatsby-background-image"

interface Props {
  className?: string
  imageName: string
  tagText?: string
}

//manage to create this component with imageName prop for loading background images

const BackgroundSection: React.FC<Props> = ({
  className,
  imageName,
  tagText,
}) => (
  <StaticQuery
    query={graphql`
      query {
        gtm: file(relativePath: { eq: "gtm_frankagathos.png" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1800) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        test: file(relativePath: { eq: "coding.jpeg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 420) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        computers: file(relativePath: { eq: "about.jpg" }) {
          childImageSharp {
            fluid(quality: 88, maxWidth: 1200) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }

        contact: file(relativePath: { eq: "contact.jpg" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1800) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => {
      // Set ImageData.
      const imageData = data[imageName].childImageSharp.fluid
      if (tagText) {
        return (
          <BackgroundImage
            Tag="section"
            className={className}
            fluid={imageData}
            backgroundColor={`#040e18`}
          >
            <p className="image-tag">{tagText}</p>
          </BackgroundImage>
        )
      } else {
        return (
          <BackgroundImage
            Tag="section"
            className={className}
            fluid={imageData}
            backgroundColor={`#040e18`}
          ></BackgroundImage>
        )
      }
    }}
  />
)

const StyledBackgroundSection = styled(BackgroundSection)`
  width: 100%;
  height: 100%;
  max-width: 100%;
  background-position: center 80%;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
`

export default StyledBackgroundSection
